import { useT } from "@/shared/i18n/useT";
import { cn } from "@/shared/lib/cn";
import { LogoMark } from "@/shared/ui/brand/LogoMark";

/** "Powered by 404 Estate", on paper or on the charcoal rail. */
export function PoweredBy({
  tone = "light",
  className,
}: {
  tone?: "light" | "dark";
  className?: string;
}) {
  const t = useT();
  return (
    <span
      dir="ltr"
      className={cn(
        "inline-flex items-center gap-1.5 text-[12px] whitespace-nowrap",
        tone === "dark" ? "text-rail-ink-subtle" : "text-ink-subtle",
        className,
      )}
    >
      <LogoMark size={20} className="size-4" />
      <span>
        {t("app.poweredByPrefix")}{" "}
        <span
          className={cn(
            "font-semibold",
            tone === "dark" ? "text-rail-ink-muted" : "text-ink-muted",
          )}
        >
          404 Estate
        </span>
      </span>
    </span>
  );
}
